import { useQuery } from '@tanstack/react-query';
import { useApiClient } from '@/shared/hooks/useApiClient';
import { createProvidersApi } from '../api/providersApi';
import { useTenant } from '@/shared/hooks/useTenant';

export const useCompanyPreferences = () => {
    const { tenant } = useTenant();
    const apiClient = useApiClient();
    const providersApi = createProvidersApi(apiClient);

    const { data, isLoading, error } = useQuery({
        queryKey: ['companyPreferences', tenant?.tenantId],
        queryFn: async () => {
            const response = await providersApi.getCompanyPreferences([]);
            return response.data.map((item: any) => ({ id: item[0], name: item[1] }));
        },
        enabled: !!tenant,
    });

    return { preferences: data ?? [], isLoading, error };
};